import {Mental2SymbolStates, SYMBOL} from "../enums/Enum";
import {Symbol} from "./Symbol";
import {gsap} from "gsap";
import TrackEntry = PIXI.spine.core.TrackEntry;

export class DeadSymbol extends Symbol {
    private _isAlreadyActive: boolean = false;

    constructor(symbolName: string, initState: Mental2SymbolStates, index: number, isActive: boolean = false) {
        super(symbolName, initState, index);
    }

    init(symbolName: string, initState: Mental2SymbolStates, index: number, isAlreadyActive: boolean = false) {
        this._isAlreadyActive = isAlreadyActive;
        this._index = index;
        this._symbolName = symbolName;
        this.name = this._symbolName + "_" + this._index;
        this.visible = true;
        this.setState(initState);
    }

    clearAnimations() {
        this._isAlreadyActive = false;
        super.clearAnimations();
    }


    public setResizeState(animName: string, loop: boolean = false): TrackEntry {
        if (this._isAlreadyActive) {
            return this.state.setAnimation(0, animName + "_loop", true)
        } else {
            const initStateAnim: PIXI.spine.core.TrackEntry = this.state.setAnimation(0, animName, loop);
            if (this._symbolName === SYMBOL.DEAD_ACTIVE && initStateAnim && animName.indexOf("loop") === -1) {
                gsap.delayedCall(0.3, () => {
                    this.state.setAnimation(0, animName + "_loop", true);
                });
            }
            return initStateAnim;
        }
    }
}